module.exports = __webpack_public_path__ + "img/page4.bab46d6a.png";